import {Injectable} from '@angular/core';
import {Notifications, Supplier, User} from '#defs';
import {NbAuthJWTToken, NbAuthService} from '@nebular/auth';
import {AnalyticsService} from '@app/services/analytics.service';

@Injectable()
export class DataService {
  get token(): string {
    return this._token;
  }

  set token(value: string) {
    this._token = value;
  }

  get user(): User {
    return this._user;
  }

  set user(value: User) {
    this._user = value;
  }

  get supplier(): Supplier {
    return this._supplier;
  }

  set supplier(value: Supplier) {
    this._supplier = value;
  }

  get notifications(): Notifications {
    return this._notifications;
  }

  set notifications(value: Notifications) {
    this._notifications = value;
  }

  get userSetting(): { currency2, currency3, country } {
    return this._user.setting;
  }

  set userSetting(value) {
    this._user.setting = value;
  }

  private _token: string;
  private _user: User = null;
  private _supplier: Supplier;
  private _notifications: Notifications = {pendingOrders: 0};

  constructor(private authService: NbAuthService,
              private analytics: AnalyticsService) {
    try {
      this.authService.onTokenChange()
        .subscribe((token: NbAuthJWTToken) => {
          if (token.isValid()) {
            this.user = token.getPayload();
            this.token = token.toString();
            this.analytics.identify(this.user);
          }
        });
    } catch (error) {
      console.error('Error on restoring user:', error);
    }
  }

  logout(): void {
    this.token = null;
    this.user = null;
    this.supplier = null;
    localStorage.removeItem('auth_app_token');
  }

  localStorage(): boolean {
    return typeof (Storage) !== void (0) && !!localStorage;
  }

  get(key: string = 'auth_app_token'): string | undefined {
    if (this.localStorage()) {
      return localStorage.getItem(key);
    } else {
      return null;
    }
  }
}
